import { render, staticRenderFns } from "./DownloadOptionPanel.vue?vue&type=template&id=68134435&scoped=true"
import script from "./DownloadOptionPanel.vue?vue&type=script&lang=ts"
export * from "./DownloadOptionPanel.vue?vue&type=script&lang=ts"
import style0 from "./DownloadOptionPanel.vue?vue&type=style&index=0&id=68134435&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68134435",
  null
  
)

export default component.exports